import { ROUTER_NAMES } from '../routerNamesConfig'

// Паспорт осмотра — отдельный роут вне меню, вкладок у него нет: разделы идут
// сплошной лентой, поэтому children не заводится.
export const INSPECTION_REPORT_CARD_CONFIG = {
	path: 'inspection-report/:cardId',
	name: ROUTER_NAMES.INSPECTION_REPORTS.CARD,
	component: () =>
		import('@/views/company/cards/inspectionReport/CompanyCardInspectionReportView.vue'),
}
